module.exports = __webpack_public_path__ + "img/public/SiteIcons/moreIcon.svg?703543f8";